import "./Projects.css";
import React from "react";
import { Container } from "react-bootstrap/";
import { useInView } from "react-intersection-observer";
import ProjectSection from "./ProjectSection";
import projects from "./ProjectsData";

function Projects() {
  const { ref: projectsRef, inView: projectsVisible } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <Container fluid className="projectsSection py-6" id="projects" ref={projectsRef}>
      <Container className={`${projectsVisible ? "fade-in-up" : "opacity-0"}`}>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Featured Technical Projects</h2>
          <div className="titleHr" />
        </div>

        {projects.map((project) => (
          <ProjectSection key={project.id || project.title} {...project} />
        ))}
      </Container>
    </Container>
  );
}

export default Projects;
